import { useEffect } from "react"
import * as querystring from "querystring"

export const SESSION_STORAGE_KEY_UTM = "track_utm"
export const SESSION_STORAGE_KEY_REFERER = "track_referer"

export interface IUtm {
  utm_source?: string // 'baidu'
  utm_medium?: string // 'cpc'
  utm_campaign?: string // 'TiDBpp'
  utm_term?: string // '375708768640'
}

export default function useTrack() {
  useEffect(() => {
    catchUtm()
    catchReferer()
  }, [])
}

export function catchUtm() {
  if (window.sessionStorage.getItem(SESSION_STORAGE_KEY_UTM)) return
  const params: IUtm = querystring.parse(window.location.search.slice(1))
  window.sessionStorage.setItem(SESSION_STORAGE_KEY_UTM, JSON.stringify(params))
}

export function catchReferer() {
  if (window.sessionStorage.getItem(SESSION_STORAGE_KEY_REFERER)) return
  const referer = window.document.referrer
  window.sessionStorage.setItem(SESSION_STORAGE_KEY_REFERER, referer)
}

export function getUtm(): IUtm {
  const str = window.sessionStorage.getItem(SESSION_STORAGE_KEY_UTM) ?? ""
  return JSON.parse(str)
}

export function getReferer(): string {
  const str = window.sessionStorage.getItem(SESSION_STORAGE_KEY_REFERER) ?? ""
  return str
}
